import GB_EXT_1 from "./GB_EXT_1";
export default {
  GB_EXT_1,
};
